const pt = {
  common: {
    nav: { services: "Serviços", about: "Sobre", guides: "Guias", contact: "Contato" },
    cta: "Iniciar projeto",
    language: "Idioma",
    themeToLight: "Mudar para modo claro",
    themeToDark: "Mudar para modo escuro",
    menuOpen: "Abrir menu",
    menuClose: "Fechar menu",
    optional: "opcional",
    reply: "Respondemos em até 7 horas.",
    scroll: "Role",
  },
  footer: {
    tagline: "Automação com IA, sites e apps para equipes que querem deixar o trabalho repetitivo com os sistemas.",
    company: "Empresa",
    policies: "Políticas",
    elsewhere: "Redes",
    location: "Bikaner, Rajastão, Índia · Atendemos no mundo todo",
    legal: {
      terms: "Termos e condições",
      privacy: "Política de privacidade",
      refund: "Política de reembolso",
      return: "Política de devolução",
      cancellation: "Política de cancelamento",
      shipping: "Política de entrega",
    },
  },
  cookie: {
    title: "Cookies, com a sua permissão",
    body: "Usamos cookies essenciais para o site funcionar. Com o seu consentimento, também usamos cookies de análise para melhorá-lo.",
    accept: "Aceitar todos",
    reject: "Apenas essenciais",
    policy: "Política de privacidade",
  },
  cta: {
    title: "Tem um processo que deveria rodar sozinho?",
    body: "Conte o que você precisa. Respondemos em até 7 horas.",
    primary: "Começar a conversa",
    secondary: "Ver serviços",
  },
  home: {
    hero: {
      eyebrow: "Estúdio de automação com IA e software",
      titleA: "Criamos sistemas",
      titleB: "que trabalham por você.",
      lede: "Agentes de IA, automações, sites e apps — projetados, desenvolvidos e entregues de ponta a ponta.",
      primary: "Iniciar projeto",
      secondary: "Ver nosso trabalho",
      tags: ["Agentes de IA", "Automação", "Apps web", "Apps móveis", "Dados", "Vídeo com IA"],
    },
    marquee: ["Agentes de IA", "Sistemas RAG", "Automação", "Sites", "Apps web", "Apps móveis", "Web scraping", "Vídeo com IA", "Python", "n8n"],
    stats: [
      { value: 4, suffix: "+", label: "anos criando sistemas de IA" },
      { value: 100, suffix: "+", label: "fluxos automatizados" },
      { value: 7, suffix: "h", label: "tempo máximo de resposta" },
    ],
    services: { label: "O que fazemos", title: "Quatro formas de ajudar.", more: "Todos os serviços" },
    work: {
      label: "Trabalhos",
      title: "Projetos no ar, entregues por nós.",
      intro: "Abra qualquer cartão para ver o projeto real.",
      nextLabel: "Seu projeto",
      nextTitle: "Pode ser o próximo.",
      nextBody: "Sites, apps e automação, de ponta a ponta.",
      nextCta: "Conte para nós",
      visit: "abrir o site em nova aba",
    },
    process: {
      label: "Como trabalhamos",
      title: "Da ideia ao lançamento em quatro passos.",
      steps: [
        { title: "Descobrir", desc: "Uma conversa gratuita para entender seu objetivo." },
        { title: "Definir", desc: "Um plano escrito e claro, com prazos." },
        { title: "Construir", desc: "Demos funcionando a cada etapa." },
        { title: "Lançar", desc: "Entrada no ar e suporte depois." },
      ],
    },
    testimonials: { label: "Clientes", title: "O que nossos clientes dizem." },
  },
  services: {
    eyebrow: "Serviços",
    title: "Serviços focados no seu objetivo.",
    lede: "Todo projeto começa com uma conversa gratuita.",
    timeline: "Prazo típico",
    included: "O que inclui",
    tools: "Ferramentas",
    showTools: "Ver ferramentas",
    hideTools: "Ocultar ferramentas",
    options: "Formas de começar",
    choose: "Escolher",
    discuss: "Fale sobre seu projeto",
    extrasTitle: "Também oferecemos",
    extras: ["Consultoria em IA", "Arquitetura de sistemas", "Integração de APIs", "Cloud e DevOps", "Manutenção e suporte", "Engenheiros dedicados"],
    items: {
      "ai-automation": {
        title: "Automação com IA",
        tagline: "Agentes e assistentes que tiram o trabalho repetitivo da sua equipe.",
        timeline: "2–12 semanas",
        includes: ["Mapeamento de processos", "Chatbots e agentes de IA", "Assistentes de conhecimento (RAG)", "Integração com CRM e ferramentas", "30 dias de suporte"],
        plans: [
          { name: "Automação inicial", note: "Um fluxo · 2–3 semanas" },
          { name: "Suíte de automação", note: "Vários fluxos · 4–6 semanas" },
          { name: "Sistemas de IA corporativos", note: "Integração completa · 8–12 semanas" },
        ],
      },
      "web-development": {
        title: "Sites e apps web",
        tagline: "Sites e apps rápidos, modernos e fáceis de gerenciar.",
        timeline: "1–10 semanas",
        includes: ["Design UI/UX", "Desenvolvimento responsivo", "Painel administrativo", "SEO e desempenho", "60 dias de suporte"],
        plans: [
          { name: "Site institucional estático", note: "5–7 páginas · 1–2 semanas" },
          { name: "Site dinâmico com painel", note: "Painel admin · 3–4 semanas" },
          { name: "App web sob medida", note: "Recursos sob medida · 6–10 semanas" },
        ],
      },
      "python-automation": {
        title: "Python e dados",
        tagline: "Scripts, scrapers e pipelines que rodam sozinhos.",
        timeline: "3 dias–4 semanas",
        includes: ["Scripts sob medida", "Web scraping", "Processamento de dados", "Tarefas agendadas", "Logs e documentação"],
        plans: [
          { name: "Script de automação", note: "Uma tarefa · 3–5 dias" },
          { name: "Solução de web scraping", note: "Várias páginas · 1–2 semanas" },
          { name: "Pipeline de dados complexo", note: "Várias fontes · 2–4 semanas" },
        ],
      },
      "ai-video": {
        title: "Vídeo e avatares com IA",
        tagline: "Conteúdo em vídeo em escala, sem editores.",
        timeline: "2–10 semanas",
        includes: ["Avatares personalizados", "Síntese de voz", "Do roteiro ao vídeo", "Identidade da marca", "Treinamento da equipe"],
        plans: [
          { name: "Vídeo com IA básico", note: "Um avatar · 2–3 semanas" },
          { name: "Sistema de avatares profissional", note: "Clonagem de voz · 4–5 semanas" },
          { name: "Plataforma de vídeo corporativa", note: "API e white-label · 6–10 semanas" },
        ],
      },
    },
  },
  about: {
    eyebrow: "Sobre",
    title: "Uma equipe pequena que cria IA prática.",
    lede: "Trocamos trabalho repetitivo por sistemas confiáveis — de um script a uma plataforma completa.",
    storyLabel: "Nossa história",
    story: "Criamos a Optivra Tech para levar a IA moderna ao dia a dia das empresas. Primeiro entendemos como você trabalha; depois construímos o que faz sentido.",
    valuesLabel: "O que nos guia",
    values: [
      { title: "Missão", desc: "Crescimento mensurável com IA e automação práticas." },
      { title: "Visão", desc: "O parceiro de tecnologia das empresas que crescem." },
      { title: "Compromisso", desc: "Qualidade, comunicação clara e resultados reais." },
    ],
    skillsLabel: "Especialidades",
    skillsTitle: "No que somos bons.",
    skillsHint: "Passe o mouse ou toque em um cartão para ver as ferramentas.",
    skills: [
      { title: "IA e ML", tools: "OpenAI · LangChain · RAG · PyTorch" },
      { title: "Backend", tools: "Python · FastAPI · Node.js · Django" },
      { title: "Frontend", tools: "React · Next.js · TypeScript · Tailwind" },
      { title: "Dados", tools: "MongoDB · PostgreSQL · Redis · Pinecone" },
      { title: "Cloud", tools: "AWS · Google Cloud · Azure · Docker" },
      { title: "Automação", tools: "n8n · Selenium · Scrapy · Airflow" },
    ],
    teamLabel: "A equipe",
    team: ["Engenheiros de IA e automação", "Desenvolvedores full-stack", "Arquitetos de soluções", "Engenheiros DevOps"],
    whyLabel: "Por que nós",
    why: [
      { title: "Rápidos", desc: "Ciclos curtos, demos reais." },
      { title: "Atuais", desc: "Ferramentas modernas e testadas." },
      { title: "Limpos", desc: "Código documentado e fácil de manter." },
    ],
  },
  contact: {
    eyebrow: "Contato",
    title: "Vamos conversar.",
    lede: "Conte sobre o seu projeto. Respondemos em até 7 horas.",
    name: "Nome completo",
    email: "E-mail",
    phone: "Telefone",
    subject: "Assunto",
    subjectPh: "ex.: Automatizar notas fiscais",
    message: "Mensagem",
    messagePh: "Do que você precisa e quais ferramentas usa?",
    send: "Enviar mensagem",
    sending: "Enviando…",
    privacy: "Nunca compartilhamos seus dados.",
    okTitle: "Mensagem enviada",
    okBody: "Obrigado! Respondemos em até 7 horas.",
    errTitle: "Algo deu errado",
    errBody: "Não foi possível enviar a mensagem. Tente novamente.",
    emailLabel: "E-mail",
    phoneLabel: "Telefone",
    hoursLabel: "Horário",
    hours: "Seg–Sáb, 9h–19h IST",
  },
  checkout: {
    eyebrow: "Iniciar projeto",
    title: "Conte o que você precisa.",
    lede: "Escolha a opção mais próxima. Confirmaremos o escopo com você.",
    details: "Seus dados",
    project: "Projeto",
    name: "Nome completo",
    company: "Empresa",
    email: "E-mail",
    phone: "Telefone",
    service: "Serviço",
    selectService: "Selecione um serviço",
    option: "Opção",
    selectOption: "Selecione uma opção",
    notes: "Notas do projeto",
    notesPh: "O que deve fazer? Com quais ferramentas deve se conectar?",
    agree: "Concordo com os",
    and: "e a",
    submit: "Enviar solicitação",
    submitting: "Enviando…",
    summary: "Resumo",
    summaryService: "Serviço",
    summaryOption: "Opção",
    next: "Respondemos em até 7 horas para confirmar escopo e próximos passos.",
    empty: "Selecione um serviço e uma opção.",
    perks: ["Processo seguro", "Reembolso em até 7 dias", "Resposta em até 7 horas"],
    refundLink: "Política de reembolso",
    termsTitle: "Termos obrigatórios",
    termsBody: "Aceite os termos para continuar.",
    okTitle: "Solicitação recebida",
    okBody: "Obrigado! Entraremos em contato em até 7 horas.",
    errTitle: "Algo deu errado",
    errBody: "Não foi possível enviar a solicitação. Tente novamente.",
  },
  guide: {
    eyebrow: "Guias",
    title: "Guias práticos baseados em projetos reais.",
    lede: "Manuais passo a passo sobre IA, automação e carreira.",
    badges: ["Download imediato em PDF", "Cópia enviada por e-mail", "Pagamento seguro via PhonePe"],
    listLabel: "Guias disponíveis",
    listTitle: "Escolha um guia.",
    mins: "min",
    levels: { "All Levels": "Todos os níveis", Beginner: "Iniciante", Intermediate: "Intermediário", Advanced: "Avançado" },
    choose: "Escolher",
    selected: "Escolhido",
    items: {
      g0: "Um plano de 30–45 dias para conquistar a vaga: currículo, entrevistas e contatos.",
      g1: "Modelos de difusão, nós personalizados e prototipagem rápida no ComfyUI.",
      g2: "Crie sistemas autônomos que substituem o trabalho manual.",
      g3: "Bancos vetoriais, chunking e implantação de agentes de conhecimento.",
      g4: "Hospede o n8n e crie fluxos entre apps com webhooks.",
    },
    buyLabel: "Pagamento",
    buyTitle: "Garanta sua cópia.",
    buySub: "Usado para a nota fiscal e para enviar o link de download.",
    name: "Nome completo",
    phone: "Telefone",
    email: "E-mail",
    country: "País",
    countries: { India: "Índia", "United States": "Estados Unidos", "United Kingdom": "Reino Unido", Canada: "Canadá", Australia: "Austrália", Germany: "Alemanha", Other: "Outro" },
    gst: "Número GST",
    company: "Nome da empresa",
    agree: "Concordo com os",
    and: "e a",
    terms: "Termos e condições",
    refund: "Política de reembolso",
    pay: "Pagar {amount} com segurança",
    redirecting: "Redirecionando para o pagamento…",
    buying: "Você está comprando",
    format: "Guia em PDF · download digital",
    price: "Preço",
    gstLine: "GST ({percent}%)",
    total: "Total",
    loadingPrice: "Carregando preço…",
    methods: "Pague com UPI, cartão, internet banking ou carteira digital.",
    secure: "Os pagamentos são processados com segurança pelo PhonePe.",
    faqLabel: "Dúvidas",
    faqTitle: "Perguntas frequentes.",
    faqs: [
      { q: "Em que formato vêm os guias?", a: "Um PDF com diagramas, trechos de código e instruções passo a passo." },
      { q: "Quando vou recebê-lo?", a: "Na hora. Você vai para uma página de download e recebe uma cópia por e-mail." },
      { q: "Posso pedir reembolso?", a: "Como são downloads imediatos, os reembolsos são limitados. Veja a Política de reembolso." },
      { q: "Quem escreve os guias?", a: "Nossos engenheiros, com base nos sistemas que criam para clientes." },
    ],
    errors: {
      "Full name is required": "Informe o nome completo",
      "Email is required": "Informe o e-mail",
      "Please enter a valid email": "Informe um e-mail válido",
      "Phone number is required": "Informe o telefone",
      "Please enter a valid phone number": "Informe um telefone válido",
      "You must accept the terms": "Você precisa aceitar os termos",
      "Something went wrong. Please try again.": "Algo deu errado. Tente novamente.",
    },
  },
  success: {
    verifying: "Confirmando seu pagamento…",
    pending: "O pagamento ainda está em processamento",
    checking: "Verificando novamente automaticamente ({n}/10)",
    checkAgain: "Verificar novamente",
    paid: "Pagamento recebido. Obrigado!",
    downloads: "Seus downloads",
    dlGuide: "Baixar guia (PDF)",
    dlInvoice: "Baixar nota fiscal (PDF)",
    linksNote: "Os links valem por 24 horas. Uma cópia também foi enviada ao seu e-mail.",
    expired: "Este link de download expirou",
    failed: "Não conseguimos concluir",
    support: "Falar com o suporte",
    home: "Voltar ao início",
    errors: {
      "No order ID found. Please check your payment email for order details.": "Pedido não encontrado. Confira o e-mail de pagamento para ver os detalhes.",
      "Payment failed. Please try again.": "O pagamento falhou. Tente novamente.",
      "Unable to verify payment status.": "Não foi possível verificar o pagamento.",
      "Download links have expired after 24 hours.": "Os links de download expiraram após 24 horas.",
      "Unable to fetch download links.": "Não foi possível obter os links de download.",
      "Download failed. Please try again or contact support.": "O download falhou. Tente novamente ou fale com o suporte.",
      "Something went wrong.": "Algo deu errado.",
    },
  },
  legal: { notice: "Esta política é publicada em inglês, que é a versão juridicamente vinculante." },
  work: {
    kke: { kind: "Site de cliente", summary: "Catálogo multilíngue para um fornecedor industrial que exporta para o mundo todo.", highlights: ["Inglês, francês e árabe", "12 linhas de produtos", "Orçamentos e WhatsApp"] },
    pokemac: { kind: "Produto próprio · app macOS", summary: "Um app divertido na barra de menus que reage a tapas, à tampa e ao USB.", highlights: ["macOS nativo", "Roda no dispositivo"] },
    drillbuddy: { kind: "Produto próprio · app Android", summary: "Treinos de reação por áudio para luta, MMA e badminton.", highlights: ["Google Play", "Intensidade ajustável"] },
    prayer: { kind: "Produto próprio · app Android", summary: "Um contador de orações tranquilo, com temas e progresso diário.", highlights: ["8 idiomas", "Google Play"] },
  },
};

export default pt;
